module.exports = __webpack_public_path__ + "img/figure2-main.30076321.png";